var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StandardSection"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"label",style:({ color: _vm.theme.primaryColor })},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }